var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "341px",
    height: "338px",
    viewBox: "0 0 341 338",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icone_red") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icone_red",
    fill: "current"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-105",
    points: "74.9395352 38.09713 181.972327 115.851749 209.65709 77.7546186 102.624297 6.06321109e-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-106",
    points: "12.1867572 156.581984 139.979464 122.341865 127.78783 76.8574124 1.81916215e-13 111.092655"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-107",
    points: "64.8546157 279.553844 118.663611 158.707972 75.6417733 139.549695 21.8279013 260.399467"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-108",
    points: "193.417833 316.620162 133.352092 198.755551 91.3933643 220.135876 151.45423 338"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-109",
    points: "302.669503 239.04596 173.262624 211.542689 163.470304 257.604962 292.877183 285.108233"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-110",
    points: "311.3597 105.333957 208.545213 188.584451 238.180636 225.181198 341 141.929241"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-111",
    points: "209.871662 148.960607 256.968432 148.960607 256.968432 16.6763323 209.871662 16.6763323"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dd17527fc1c75c49e69b372f9cd47d76.svg";
export { ForwardRef as ReactComponent };